import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import ButtonBase from '@material-ui/core/ButtonBase'

import withStyles from '@material-ui/core/styles/withStyles'
import AssignmentIcon from '@material-ui/icons/Assignment'
import RestoreIcon from '@material-ui/icons/Restore'
import PersonIcon from '@material-ui/icons/Person'
import EventNoteIcon from '@material-ui/icons/EventNote'

import moment from 'moment'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import { Word } from '../../../containers';
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
moment.locale('ja')

const styles = theme => ({
  dialogContent: {
    padding: 0,
  },
  recordBox: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  avatar: {
    marginRight: theme.spacing.unit * 2,
  },
  itemName: {
    marginRight: theme.spacing.unit,
  },
  diffLabel: {
    marginRight: theme.spacing.unit,
  },
  revision: {
    marginRight: theme.spacing.unit * 2,
  },
  displayName: {
    marginRight: theme.spacing.unit * 2,
  }
})

const targetProps = [
  { name: 'authorType', wid: WID.EVENT_HISTORY_DIALOG.REGISTANT_TYPE },
  { name: 'thumbnail',  wid: WID.EVENT_HISTORY_DIALOG.THUMBNAIL },
  { name: 'name',       wid: WID.EVENT_HISTORY_DIALOG.EVENT_NAME },
  { name: 'address',    wid: WID.EVENT_HISTORY_DIALOG.ADDRESS },
  { name: 'startDate',  wid: WID.EVENT_HISTORY_DIALOG.START_DATE },
  { name: 'startTime',  wid: WID.EVENT_HISTORY_DIALOG.START_TIME },
  { name: 'endDate',    wid: WID.EVENT_HISTORY_DIALOG.END_DATE },
  { name: 'endTime',    wid: WID.EVENT_HISTORY_DIALOG.END_TIME },
  { name: 'detail',     wid: WID.EVENT_HISTORY_DIALOG.DETAIL },
]

const EventHistoryDialog = withStyles(styles, { withTheme: true })((props) => {
  const { classes, theme, open, onClose, handleEnter, records } = props

  const settingsContext = useContext(SettingsContext)
  const language = settingsContext

  const dialogProps = { open, onClose, onEnter: handleEnter }
  
  var dateTime, recordBoxProps, diffList
  
  const diffRecord = (before, after) => {
    var diffList = []
    targetProps.forEach(target => {
      if (before[target.name] !== after[target.name]) {
        diffList.push(target.wid)
      }
    })
    return diffList
  }


  return (
    <Dialog {...dialogProps}>
      <DialogTitle><Word wid={WID.EVENT_HISTORY_DIALOG.DIALOG_TITLE}/></DialogTitle>
      {records.length === 0 ? (
        <DialogContent>
          <CircularProgress/>
        </DialogContent>
      ) : (
        <DialogContent className={classes.dialogContent}>
          {records.map((record, index) => {
            diffList = []
            if (records.length !== index + 1) {
              diffList = diffRecord(records[index + 1], record)
            }
            dateTime = moment(record.updateDateTime ? record.updateDateTime : record.createDateTime).format('LLL')
            recordBoxProps = {
              style: records.length === index + 1 ? {
                borderBottom: `1px solid ${theme.palette.grey[200]}`
              } : undefined
            }
            return (
              <div className={classes.recordBox} key={record.id} {...recordBoxProps}>
                <div className={classes.flexBox}>
                  <RestoreIcon className={classes.icon}/>
                  <Typography className={classes.revision}><Word wid={WID.EVENT_HISTORY_DIALOG.REVISION}/>{`: ${record.rev}`}</Typography>
                  <ButtonBase component={Link} to={makePath(`/event/${record.eventId}?rev=${record.rev}`, language)} onClick={onClose}>
                    <Typography color='primary'><Word wid={WID.EVENT_HISTORY_DIALOG.SHOW_BUTTON}/></Typography>
                  </ButtonBase>
                </div>
                <div className={classes.flexBox}>
                  <PersonIcon className={classes.icon}/>
                  <Typography className={classes.displayName}>{`${record.author.displayName}`}</Typography>
                  <ButtonBase component={Link} to={makePath(`/user/${record.author.userName}`, language)} onClick={onClose}>
                    (<Typography color='primary'>{`@${record.author.userName}`}</Typography>)
                  </ButtonBase>
                </div>
                <div className={classes.flexBox}>
                  <EventNoteIcon className={classes.icon}/>
                  <Typography><Word wid={WID.EVENT_HISTORY_DIALOG.UPDATE_DATETIME}/>{`: ${dateTime}`}</Typography>
                </div>
                {records.length !== index + 1 && (
                  <div className={classes.flexBox}>
                    <AssignmentIcon className={classes.icon}/>
                    <Typography>
                      <Word wid={WID.EVENT_HISTORY_DIALOG.CHANGES}/>{`: `}
                      {diffList.map(wid => {
                        return (<span className={classes.diffLabel} key={wid}><Word wid={wid}/></span>)
                      })}
                    </Typography>
                  </div>
                )}
              </div>
            )
          })}
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
})

export default EventHistoryDialog


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventHistoryDialog.js